// extracted by mini-css-extract-plugin
export default {"correct":"box_correct__eLMdq","present":"box_present__4zsfp","absent":"box_absent__n4+ip","empty":"box_empty__ng3q1","edit":"box_edit__BOVF3"};